import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-4of10--xl gfu-left-3of10--xl gfu-1of2--l gfu-left-1of4--l gfu-4of6--m gfu-left-1of6--m gfu-1of1" }
const _hoisted_4 = {
  class: "gfu-box gfu-box--thick _mt-6 _mb-3",
  "data-qa": "complete-user-account-form"
}
const _hoisted_5 = { class: "gfu-heading gfu-heading--soft gfu-box__title gfu-box__title--accent _mb-1" }
const _hoisted_6 = { class: "gfu-subheading gfu-subheading--bold _tac" }
const _hoisted_7 = { class: "_tc--gray" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_field = _resolveComponent("field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_localize = _resolveComponent("localize")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.Account.CompleteAccountHeader), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Account.CompleteAccountIntroParagraph), 1 /* TEXT */),
          _createVNode(_component_text_field, {
            modelValue: $data.model.fullName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.fullName) = $event)),
            name: "model.fullName",
            type: "text",
            "display-name": _ctx.Resources.Account.CompleteAccountFullNameFieldLabel,
            "data-qa": "complete-user-account:NameField"
          }, null, 8 /* PROPS */, ["modelValue", "display-name"]),
          _createVNode(_component_text_field, {
            modelValue: $data.model.nickname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.nickname) = $event)),
            name: "model.nickname",
            type: "text",
            "display-name": _ctx.Resources.Account.CompleteAccountNicknameFieldLabel,
            "data-qa": "complete-user-account:NicknameField"
          }, null, 8 /* PROPS */, ["modelValue", "display-name"]),
          _createVNode(_component_text_field, {
            "model-value": $props.email,
            name: "model.email",
            type: "text",
            "read-only": true,
            "display-name": _ctx.Resources.Account.CompleteAccountEmailFieldLabel,
            "data-qa": "complete-user-account:EmailField"
          }, null, 8 /* PROPS */, ["model-value", "display-name"]),
          (!$props.isFromExternalProvider)
            ? (_openBlock(), _createBlock(_component_field, {
                key: 0,
                name: "model.password",
                "display-name": _ctx.Resources.Account.CompleteAccountPasswordFieldLabel,
                class: "_mb-3",
                "data-qa": "complete-user-account:PasswordField"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.password) = $event)),
                    class: "gfu-field__input",
                    type: "password",
                    "data-qa": "text-field-input"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $data.model.password]
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["display-name"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_checkbox_field, {
            modelValue: $data.model.subscribeToNewsletter,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.subscribeToNewsletter) = $event)),
            name: "model.subscribeToNewsletter",
            class: "_mt-3",
            condensed: true,
            "data-qa": "complete-user-account:NewsletterCb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_localize, {
                resource: _ctx.Resources.Account.CompleteAccountNewsletterConsentLabel
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_tooltip, {
                    "format-key": "0",
                    text: _ctx.Resources.Account.CompleteAccountNewsletterTooltipText
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("em", _hoisted_7, [
                        _createVNode(_component_base_icon, { name: "circle-info" })
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["text"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_checkbox_field, {
            modelValue: $data.model.termsAccepted,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.model.termsAccepted) = $event)),
            name: "model.termsAccepted",
            "display-name": _ctx.Resources.Account.CompleteAccountTermsOfServiceFieldName,
            class: "_mt-1",
            condensed: true,
            "data-qa": "complete-user-account:TermsCb"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_localize, {
                  resource: _ctx.Resources.Account.CompleteAccountTermsConsentLabel
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      "format-key": "0",
                      class: "gfu-link gfu-link--accent",
                      href: $props.termsAndConditionsUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "data-qa": "complete-user-account:TosLink"
                    }, _toDisplayString(_ctx.Resources.Account.CompleteAccountTosLink), 9 /* TEXT, PROPS */, _hoisted_8),
                    _createElementVNode("a", {
                      "format-key": "1",
                      class: "gfu-link gfu-link--accent",
                      href: $props.privacyPolicyUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "data-qa": "complete-user-account:PrivacyPolicyLink"
                    }, _toDisplayString(_ctx.Resources.Account.CompleteAccountPrivacyPolicyLink), 9 /* TEXT, PROPS */, _hoisted_9)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "display-name"]),
          _createVNode(_component_field, { class: "_mt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                theme: "accent",
                class: "_w-100",
                disabled: $options.hasErrors,
                onClick: $options.onSubmit,
                "data-qa": "complete-user-account:ContinueBtn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Account.ContinueActionButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
        ])
      ])
    ])
  ]))
}